<div class="card border-0 shadow-sm">
  <div class="card-header bg-primary">
    <div class="row align-items-center">
      <div class="col-xl mb-3 mb-xl-0">
        <h5 class="text-white mb-0">
          {{ data.game }}
        </h5>
      </div>

      <div class="col-auto">
        <button
          type="button"
          class="btn btn-secondary me-xl-3"
          (click)="collapsed = !collapsed"
        >
          <i
            class="fa-solid fa-lg"
            [ngClass]="collapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
          ></i>
        </button>

        <button
          type="button"
          class="btn btn-light"
          ngbPopover="Delete"
          triggers="mouseenter:mouseleave"
          (click)="deleteMatch()"
        >
          <i class="fa-solid fa-trash fa-lg"></i>
        </button>
      </div>
    </div>
  </div>

  <div
    class="card-body text-center p-0"
    #collapse="ngbCollapse"
    [(ngbCollapse)]="collapsed"
  >
    <div class="container bg-secondary-subtle py-3">
      <div class="row gy-4 justify-content-evenly">
        <div class="col-md-5 col-input mb-4 mb-xl-0">
          <label for="game" class="form-label"> Game </label>

          <input
            id="game"
            type="text"
            class="form-control"
            [(ngModel)]="data.game"
          />
        </div>

        <div class="col-md-5 col-input mb-4 mb-xl-0">
          <label for="date" class="form-label"> Date </label>

          <app-custom-date-picker
            [date]="data.date"
            (onDateChange)="data.date = $event"
          ></app-custom-date-picker>
        </div>

        <div class="col-md-6 col-lg-3 col-input mb-4 mb-xl-0">
          <label for="units-received" class="form-label">
            Units Received
          </label>

          <app-custom-input-number
            [data]="data.unitsReceived"
            placeholder="Units Received"
            (onDataChange)="
              data.unitsReceived = $event; calculateTimeReceived()
            "
          ></app-custom-input-number>
        </div>

        <div class="col-md-6 col-lg-3 col-input mb-4 mb-xl-0">
          <label for="time-received" class="form-label"> Time Received </label>

          <p class="fw-bold my-auto">
            {{
              ('' + data.timeReceived.minutes).padStart(2, '0') +
                ':' +
                ('' + data.timeReceived.seconds).padStart(2, '0')
            }}
          </p>
        </div>

        <div class="col-md-6 col-lg-3 col-input mb-4 mb-xl-0">
          <label for="virwership" class="form-label">
            Viewership {{ viewership() ? '(' + viewership() + ')' : '' }}
          </label>

          <app-custom-input-number
            [data]="data.viewership"
            placeholder="Viewership"
            (onDataChange)="data.viewership = $event; calculateTimeReceived()"
          ></app-custom-input-number>
        </div>

        <div class="col-md-6 col-lg-3 col-input mb-4 mb-xl-0">
          <label for="delivered" class="form-label"> Delivered </label>

          <p class="fw-bold my-auto">
            {{ data.delivered | number : '1.0-0' }}
          </p>
        </div>
      </div>
    </div>

    <div class="container rounded-bottom text-bg-secondary py-4">
      <div class="row">
        <div class="col-lg-6 px-0">
          <app-media-edit
            [src]="data.leftMedia || ''"
            (onSelectFile)="handleSelectMedia($event, 0)"
          ></app-media-edit>
        </div>

        <div class="col-lg-6 px-0">
          <app-media-edit
            [src]="data.rightMedia || ''"
            (onSelectFile)="handleSelectMedia($event, 1)"
          ></app-media-edit>
        </div>
      </div>

      <div class="row pt-4">
        <div class="col-xl-6 mb-4 mb-xl-0 text-center">
          <h5 class="text-light mb-0">Left corner</h5>
        </div>

        <div class="col-xl-6 text-center">
          <h5 class="text-light mb-0">Right corner</h5>
        </div>
      </div>
    </div>
  </div>
</div>
